import { css } from 'emotion';

import { minWidth, tablet } from './screenSizes';

export const svgIcon = css`
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
  margin-right: 3px;

  ${minWidth(tablet)} {
    margin-right: 5px;
  }
`;

// 48px is googles touch target size recommendation
export const touchTargetHeightPadding = originalHeight => css`
  padding: calc((48px - ${originalHeight}) / 2) 0;
`;



// WEBPACK FOOTER //
// ./app/mixins.js